import { Navigate } from 'react-router-dom';
import './App.css';
import Header from './components/HeaderMarsComplete.js';
import Main from './components/Main';
import Vip2 from './components/MarsFamilyComplete.jsx/MarsFamilyComplete.jsx';

function MarsFamilyCompleteApp() {
    var role = localStorage.getItem('role');

    switch (role) {
        case 'Visit Requester':
        case 'Requester':
            return (
                <div>
                    <Navigate to={`/AppRequester`} replace />
                </div>
            )
        case 'MLTUser':
        case 'MLTCoordinator':
            return (
                <div>
                    <Navigate to={`/AppMltEvent`} replace />
                </div>
            )
        case 'Admin':
            return (
                <div>
                    <Navigate to={`/AppAdmin`} replace />
                </div>
            )
        case 'Family':
        case 'FamilyCoordinator':
            return (
                <div>
                    <Header />
                    <Main />
                    <Vip2 />
                </div>
            )
        default:
            return (
                <div>
                    <Navigate to="/" replace />
                </div>
            )
    }
}
export default MarsFamilyCompleteApp;